exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tabla{\n    position:relative;\n    margin:auto;\n    width:100%;\n    /*left:-15%*/;\n }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/compras/pago-grupo/pago-grupo.component.css
// module id = ../../../../../src/app/components/compras/pago-grupo/pago-grupo.component.css
// module chunks = main